import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';
import { AuthService } from '~shared/servicios/auth.service';
import { HttpRequestService } from '~shared/servicios/HttpRequestService';

@Injectable({
  providedIn: 'root'
})
export class InicioService {

  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly triidyServiceUrlRest = `${environment.apiTriidyUrlRest}`;
  private readonly triidyServiceUrlWallet = `${environment.apiTriidyUrlWallet}`;
  paisSelected;

  constructor(private http: HttpClient,
    private httpRequestService: HttpRequestService, private authService: AuthService) { }

  getTienda(): Observable<any> {
    const id = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetTienda`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  getPaisesBodegas(): Observable<any> {
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());

    const body = {
      key,
      id_tienda,
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/api/GetPaisesAutorizados`, body)
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  getSaldo(usuario: any): Observable<any> {

    const key = atob(this.authService.leerToken());
    const token = environment.serviceToken;
    const id_tienda = atob(this.authService.leerIdTienda());
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda,
      usuario,
      token,
      key,
      codigo_pais
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetSaldo`, {
        params,
      })
      .pipe(
        map((resp) => {
          // console.log('getSaldo', resp)
          return resp;
        }, err => {
          // console.log('error', err);
        })
      );
  }

  getVentas(usuario: any, fecha_inicio: any, fecha_fin: any, tipo_consulta: any): Observable<any> {
    /* fecha inicio y fecha fin son en AAAMMDD ej 20201027 */
    /*     'Ventas' trae todas las ventas de un dia incluyendo anuladas y devueltas
        'Devoluciones' Cuenta como devolucion el dia q se genera, es decir si se creo el 10 de noviembre
        y la devuelven hoy la devolucion queda registrada para este reporte e 10 de noviembre
        'Anulaciones'
        */
    const key = atob(this.authService.leerToken());
    const token = environment.serviceToken;
    const id_tienda = atob(this.authService.leerIdTienda());
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda,
      usuario,
      fecha_inicio,
      fecha_fin,
      tipo_consulta,
      token,
      key,
      codigo_pais
    });

    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetVentas`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        }, err => {
          // console.log('error', err);
        })
      );
  }

  getConsolidado(usuario: any, fecha_inicial_consulta: any, fecha_final_consulta: any): Observable<any> {
    /* fecha inicio y fecha fin son en AAAMMDD ej 20201027 */
    /*     'Ventas' trae todas las ventas de un dia incluyendo anuladas y devueltas
        'Devoluciones' Cuenta como devolucion el dia q se genera, es decir si se creo el 10 de noviembre
        y la devuelven hoy la devolucion queda registrada para este reporte e 10 de noviembre
        'Anulaciones'
        */
    const key = atob(this.authService.leerToken());
    const token = environment.serviceToken;
    const id_tienda = atob(this.authService.leerIdTienda());
    const nombre_pais = atob(sessionStorage.getItem(btoa('countrySelectedName')));
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda,
      usuario,
      fecha_inicial_consulta,
      fecha_final_consulta,
      token,
      key,
      nombre_pais
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/GetConsolidado`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        }, err => {
          // console.log('error', err);
        })
      );
  }

  getNovedadesDashboard(): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key,
      codigo_pais
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/NovedadesDashboard`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  getTicketsDashboard(): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/TicketsDashboard`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }


  modificaContrasenna(oldP: any, newP: any): Observable<any[]> {
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());

    const body = {
      key: key,
      token: token,
      id_tienda_login: id_tienda,
      old_psw: oldP,
      psw: newP,
    };
    /*
    Recibe
    {
     "token": "7jh95ññtñue2.y3-pw57",
     "key": "Ym8d4sh4a2373tycyr",
     "id_tienda_login": "2",
     "old_psw": "123",
     "psw": "1234"
    }
    */

    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/api/ActualizarClave`, body)
      .pipe(
        map((respuesta) => {
          // console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

  consultaMaestra(consulta): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key,
      consulta
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/ConsultaMaestra`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  consultaMaestraText(consulta): Observable<any> {
    const id_tienda_login = atob(this.authService.leerIdTienda());
    const token = environment.serviceToken;
    const key = atob(this.authService.leerToken());
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda_login,
      token,
      key,
      consulta
    });
    return this.http
      .get(`${this.triidyServiceUrl}/ConsultaMaestra`, {
        params,
        responseType: 'text'
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  getMovimientos(fInicio, fFin): Observable<any> {
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());
    const codigo_pais = atob(sessionStorage.getItem(btoa('countrySelected')));
    const body = {
      key: key,
      pais: codigo_pais,
      user_or_tienda: id_tienda,
      tipo: 'Tienda',
      fecha_inicio: fInicio,
      fecha_fin: fFin
    };

    return this.http
      .post<any>(`${this.triidyServiceUrlWallet}/api/Detalles`, body)
      .pipe(
        map((respuesta) => {
          // console.log('resp', respuesta);
          return respuesta;
        }, (err) => {
          // console.log('err', err);
        })
      );
  }

  setCoinDetail(): String {
    const idCountry = atob(sessionStorage.getItem(btoa('countrySelected')));
    if (idCountry === '57') {
      return 'COP';
    } else if (idCountry === '593' || idCountry === '1') {
      return 'USD';
    } else if (idCountry === '11') {
      return 'CAD';
    } else if (idCountry === '52') {
      return 'MXN';
    }
  }

  setPointsCoin(valor): any {
    const idCountry = atob(sessionStorage.getItem(btoa('countrySelected')));
    // VALORES MAYORES
    if (valor > 0) {
      /* COLOMBIA */
      if (idCountry === '57') {
        const valor2 = valor.toString();
        let valorFinal = valor2;
        let i;
        for (i = 0; i <= valorFinal.length; i++) {
          if (i === 4 || i === 8 || i === 12 || i === 16) {
            let num = i - 1;
            valorFinal = valorFinal.slice(0, valorFinal.length - num) + ',' + valorFinal.slice(-num);
          }
        }
        return valorFinal;
      } /* USA, CANADA, ECUADOR */
      else if (idCountry === '593' || idCountry === '1' || idCountry === '11' || idCountry === '52') {
        const valor2 = valor.toString();
        let valor3 = valor2.replace(',', '.');
        let valorFinal = valor3.split('.');
        if (valorFinal.length > 1) {
          let vF1 = valorFinal[0];
          let decimalVF1 = valorFinal[1].slice(0, 2);
          for (let i = 0; i <= vF1.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF1 = vF1.slice(0, vF1.length - num) + ',' + vF1.slice(-num);
            }
          }
          vF1 = vF1 + '.' + decimalVF1;
          return vF1;
        } else {
          let vF2 = valorFinal[0];
          for (let i = 0; i <= vF2.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF2 = vF2.slice(0, vF2.length - num) + ',' + vF2.slice(-num);
            }
          }
          return vF2;
        }
      }
    } // VALORES MENORES 
    else if (valor < 0) {
      /* COLOMBIA */
      if (idCountry === '57') {
        const valor2 = valor.toString();
        let valorFinal = valor2.replace('-', '');
        let i;
        for (i = 0; i <= valorFinal.length; i++) {
          if (i === 4 || i === 8 || i === 12 || i === 16) {
            let num = i - 1;
            valorFinal = valorFinal.slice(0, valorFinal.length - num) + ',' + valorFinal.slice(-num);
          }
        }
        valorFinal = '-' + valorFinal;
        return valorFinal;
      } /* USA, CANADA, ECUADOR */
      else if (idCountry === '593' || idCountry === '1' || idCountry === '11' || idCountry === '52') {
        const valor2 = valor.toString();
        let valor3 = valor2.replace(',', '.');
        let valor4 = valor3.replace('-', '');
        let valorFinal = valor4.split('.');
        if (valorFinal.length > 1) {
          let vF1 = valorFinal[0];
          let decimalVF1 = valorFinal[1].slice(0, 2);
          for (let i = 0; i <= vF1.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF1 = vF1.slice(0, vF1.length - num) + ',' + vF1.slice(-num);
            }
          }
          vF1 = '-' + vF1 + '.' + decimalVF1;
          return vF1;
        } else {
          let vF2 = valorFinal[0];
          for (let i = 0; i <= vF2.length; i++) {
            if (i === 4 || i === 8 || i === 12 || i === 16) {
              let num = i - 1;
              vF2 = vF2.slice(0, vF2.length - num) + ',' + vF2.slice(-num);
            }
          }
          vF2 = '-' + vF2;
          return vF2;
        }
      }
    } else {
      /* COLOMBIA */
      if (idCountry === '57') {
        const valor2 = valor;
        return valor2;
      } /* USA, CANADA, ECUADOR */
      else if (idCountry === '593' || idCountry === '1' || idCountry === '11' || idCountry === '52') {
        const valor2 = valor;
        return valor2;
      }
    }

  }
}
